import { Users } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { crewWebManifest } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  crewWebManifest,
  {
    CrewPage: () => import('./CrewPage'),
  },
  {
    icons: { Users },
  },
);
